module.exports = __webpack_public_path__ + "static/media/DeleteX.c759c323.svg";